import { useLayoutEffect } from "react"

const React = require("react")
const { useState, createContext, useContext } = require("react")

const { RES } = require("utils/constants")

export const DEVICE = {
  mobile: "mobile",
  tablet: "tablet",
  desktop: "desktop"
}

export const ORIENTATION = {
  portrait: "portrait",
  landscape: "landscape"
}

const QUERY_MOBILE = `(max-width: ${RES._512}px)`
const QUERY_TABLET = `(min-width: ${RES._512}px) and (max-width: ${RES._768}px)`
const QUERY_DESKTOP = `(min-width: ${RES._768}px)`
const QUERY_PORTRAIT = `(orientation: portrait)`

export const Context = createContext({
  device: null,
  orientation: null
})

export const useBrowserData = () => {
  const { device, orientation } = useContext(Context)

  return {
    isMobile: device === DEVICE.mobile,
    isTablet: device === DEVICE.tablet,
    isDesktop: device === DEVICE.desktop,
    isPortrait: orientation === ORIENTATION.portrait
  }
}

export const wrapPageElement = ({ element }) => {
  const [device, setDevice] = useState(DEVICE.mobile)
  const [orientation, setOrientation] = useState(ORIENTATION.portrait)

  useLayoutEffect(() => {
    const mobileMediaQuery = window.matchMedia(QUERY_MOBILE)
    const tabletMediaQuery = window.matchMedia(QUERY_TABLET)
    const desktopMediaQuery = window.matchMedia(QUERY_DESKTOP)
    const portraitMediaQuery = window.matchMedia(QUERY_PORTRAIT)

    const handleDeviceChange = () => {
      if (mobileMediaQuery.matches) setDevice(DEVICE.mobile)
      else if (tabletMediaQuery.matches) setDevice(DEVICE.tablet)
      else if (desktopMediaQuery.matches) setDevice(DEVICE.desktop)
    }

    const handleOrientationChange = ({ matches }) => {
      const newOrientation = matches ? ORIENTATION.portrait : ORIENTATION.landscape
      setOrientation(newOrientation)
      // 🔄 Reload page when orientation changes
      window.location.reload()
    }

    mobileMediaQuery.addEventListener("change", handleDeviceChange)
    tabletMediaQuery.addEventListener("change", handleDeviceChange)
    desktopMediaQuery.addEventListener("change", handleDeviceChange)
    portraitMediaQuery.addEventListener("change", handleOrientationChange)

    // Initial setup
    handleDeviceChange()
    setOrientation(portraitMediaQuery.matches ? ORIENTATION.portrait : ORIENTATION.landscape)

    return () => {
      mobileMediaQuery.removeEventListener("change", handleDeviceChange)
      tabletMediaQuery.removeEventListener("change", handleDeviceChange)
      desktopMediaQuery.removeEventListener("change", handleDeviceChange)
      portraitMediaQuery.removeEventListener("change", handleOrientationChange)
    }
  }, [])

  return <Context.Provider value={{ device, orientation }}>{element}</Context.Provider>
}
